//Library Imports
import { FC, useEffect, useState, useCallback } from "react";
import store, { RootState } from "../../../store/index";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import styled from "styled-components";

// application components goes here
import Mainnav from "../../Common/Components/Mainnav";
import SettingsSidebar from "./SettingsSidebar";
import Skeleton from "./Skeleton";
import ArticleListOrder from "./ArticleListOrder";
import TemplateSwitch from "./TemplateSwitch";
import ConfirmDialog from "modules/Common/Components/ConfirmDialog";
import { checkHTMLchanges, getContentforSave, init_stripo_plugin, showLoader } from "../Scripts/DynamicStripo";
import { confirmWorkflowActiveWarning, designSkeletonLoad, getDesignHTMLService } from "./../action";
import { IDesignItem, IDesignState } from "./../Interfaces";
import { ASSET_TYPE, TEMP_ASSET_NAME } from "../../../constants/index";
import { message } from "antd";
import { getQueryEmailId } from "modules/EmailBrowser/utils";
import { DESIGN } from "constants/actionTypes";
import { getCampaignsNamesOnly } from "modules/Campaigns/CampaignAssets/actions";
import { ReactComponent as WarningIcon } from "../../../assets/img/icons/warningWhiteIcon.svg";
import { removeGillRoyIcon, addGillRoyIcon } from "utils";
import ConfirmDialogWithModal from "modules/Common/Components/ConfirmDialogWithModal";

interface DesignProps {
  redirectToPublish: boolean;
  setRedirectToPublish: (value: boolean) => void;
  toggleDisabled: boolean;
  setToggleDisabled: (value: boolean) => void;
}

const Design: FC<DesignProps> = (props: DesignProps) => {
  //Props
  const { redirectToPublish, setRedirectToPublish, toggleDisabled, setToggleDisabled } = props;

  //Constants
  let isDesign = window.location.pathname.includes("/design");
  const history = useHistory();
  const email_id = getQueryEmailId();
  const [loaded, setLoaded] = useState(false);
  const [templateStyleId, setTemplateStyleId] = useState(0);
  const [checkForShowMessageForActiveWF, setCheckForShowMessageForActiveWF] = useState(false);
  const [showMessageForActiveWF, setShowMessageForActiveWF] = useState(false);
  const design: IDesignState = useSelector((state: RootState) => state.design);
  const designData: IDesignItem = useSelector((state: RootState) => state.design.data);

  //Redux States
  const loading: boolean = useSelector((state: RootState) => state.design.loading);
  const skeletonLoading: boolean = useSelector((state: RootState) => state.design.skeletonLoading);
  let loadingArticles = useSelector((state: RootState) => state.design.articlesLoading);
  const saving = useSelector((state: RootState) => state.design.saveDesign.loading);
  const savingText = useSelector((state: RootState) => state.design.saveDesign.loadText);
  const saveSuccess = useSelector((state: RootState) => state.design.saveDesign.success);
  const saveSuccessText = useSelector((state: RootState) => state.design.saveDesign.successText);
  const saveFail = useSelector((state: RootState) => state.design.saveDesign.fail);
  const saveFailText = useSelector((state: RootState) => state.design.saveDesign.failText);
  const disablePreview = useSelector((state: RootState) => state.design.disablePreview);
  const campaignItems = useSelector((state: RootState) => state.getCampaignNames.data);
  const isDesignUpdated = useSelector((state: RootState) => state.design.isDesignUpdate);
  const editionId = useSelector((state: RootState) => state.editionData.editionId);
  const workflowCurrentState = useSelector((state: RootState) => state.editionData.workflowCurrentState);
  const workflowStatus: string = useSelector((state: RootState) => state.editionData.workflowStatus);
  const workflowActiveWarningShown = useSelector((state: RootState) => state.design.workflowActiveWarningShown);

  const warningMessage = (content: string) => {
    message.warning({
      content,
      style: {
        marginTop: '13vh',
      },
      rtl: true,
      className: 'warning-message-design',
      icon: <WarningIcon style={{ marginRight: '5px' }} />
    })
  }

  const setFieldNames = (data: IDesignItem) => {
    //set asset and campaign name in popup and header field
    if (typeof data !== 'boolean') {
      setTemplateStyleId(data.template_style_id);
    }
    setTimeout(() => {
      setToggleDisabled(false);
    }, 500);
  };

  const saveAndRedirect = (url: string, e?: any) => {
    // prompt user on exiting if design not saved
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    // store.dispatch({
    //   type: DESIGN.LOAD,
    //   loader: true,
    // });
    showLoader(true);
    setToggleDisabled(true);
    checkHTMLchanges(getContentforSave, templateStyleId, url, history, warningMessage, savePublishComplete);
  };

  const savePublishComplete = (value: boolean) => {
    // store.dispatch({
    //   type: DESIGN.LOAD,
    //   loader: value,
    // });
    showLoader(value);
    setToggleDisabled(value);
    // init_stripo_plugin(design, templateStyleId);
  };

  // const changeTemplate = useCallback((templateStyleId: number, url: string) => {
  //   setTemplateStyleId(templateStyleId);
  // }, []);

  const changeTemplate = (templateStyleId: number, url: string) => {
    setTemplateStyleId(templateStyleId);
  };

  const enableSaveButtons = (value: any) => {
    if (value === false) {
      setToggleDisabled(false);
      return;
    }
    // to handle any value other than false
    setToggleDisabled(true);
  };
  const enableHeader = () => {
    setTimeout(() => {
      setToggleDisabled(false);
    }, 2000);
  };
  const handleSaveEmail = () => {
    // saveAsComplete(true);
    setToggleDisabled(true);
    getContentforSave(templateStyleId, null, history, enableHeader);
  };

  const handleSaveAsEmail = (
    asset_name: string,
    campaign_name: string,
    campaign_id: number,
    handleCancel: any,
    showMessage?: any,
  ) => {
    showLoader(true);
    setToggleDisabled(true);
    getContentforSave(
      templateStyleId,
      null,
      history,
      showLoader,
      true,
      asset_name,
      campaign_name,
      campaign_id,
      handleCancel,
      showMessage,
      setToggleDisabled,
    );
  };
  useEffect(() => {
    // console.log('loaded: ', isDesignUpdated)
    removeGillRoyIcon()
    if (!loaded) {
      // if design not loaded get html content from api
      setLoaded(true);
      // if (campaignItems.length === 0) {
      //   getCampaignsNamesOnly();
      // }
      // console.log('useEffect[] design', design, isDesignUpdated, editionId, getQueryEmailId(), design?.data?.html)
      if (isDesignUpdated || email_id !== editionId || !design?.data?.html) {
        showLoader(true);
        setToggleDisabled(true);
        getDesignHTMLService(email_id, 0, 0, setFieldNames, true);
      } else {
        designSkeletonLoad();
        setToggleDisabled(true);
        init_stripo_plugin(design.data, design?.data?.template_style_id);
      }
    }
    return () => {
      addGillRoyIcon()
    };
  }, []);

  // redirect to publish if currently on design page
  useEffect(() => {
    if (redirectToPublish) {
      setRedirectToPublish(false);
      saveAndRedirect("/campaigns/editionedit/publish/" + window.location.search);
    }
  }, [redirectToPublish]);

  useEffect(() => {
    if (Number(designData?.template_style_id) >= 0 && designData?.template_style_id?.toString() !== templateStyleId?.toString()) {
      setTemplateStyleId(designData?.template_style_id);
    }
  }, [designData, templateStyleId]);

  useEffect(() => {
    if (!workflowActiveWarningShown && workflowStatus === 'event' && workflowCurrentState === 'active') {
      if (skeletonLoading && !checkForShowMessageForActiveWF) {
        setCheckForShowMessageForActiveWF(true);
      } else if (skeletonLoading === false && designData?.html !== "" && checkForShowMessageForActiveWF) {
        setTimeout(() => {
          setShowMessageForActiveWF(true);
        }, 1000)
      }
    }
  }, [skeletonLoading, designData, workflowCurrentState, workflowStatus, workflowActiveWarningShown]);


  return (
    <>
      <Wrapper>
        <Mainnav
          onExit={(value: string, e?: any) => {
            saveAndRedirect(value, e);
          }}
        />
        {/* {message.warning({
          content: "There are missing link(s) in this asset. Add link or remove the CTAs.",
          style: {
            marginTop: '13vh',
          },
          className: 'warning-message-design',
          icon: <WarningIcon style={{ marginRight: '5px' }} />
        })} */}
        {/* {message.warning("There are missing link(s) in this asset. Add link or remove the CTAs.")} */}

        {saving || saveSuccess || saveFail ? (
          <ConfirmDialog
            title={saveSuccess ? saveSuccessText : saveFail ? saveFailText : savingText}
            titleQuestion=""
          />
        ) : null}
        {showMessageForActiveWF ?
          <ConfirmDialogWithModal
            title={'Making edits to the email will affect the attached workflow'}
            titleQuestion=""
            onConfirm={() => {
              console.log('onConfirm');
              confirmWorkflowActiveWarning(true);
              setShowMessageForActiveWF(false);
            }}
            confirm="Okay"
          /> : null
        }
        <div className="content-inner static-layout-container">
          <div className="notification-zone"></div>
          <div className="designWraper">
            <div className={`preview-wraper`}>
              <Skeleton loading={loading || skeletonLoading} />
              {/* <Skeleton loading={true} /> */}
              <div
                id="load-template"
                {...(loading ? { className: "d-none load-template" } : { className: "load-template" })}
              ></div>
            </div>
            <div className={`settings-wraper 
            `}>
              {/* ${loading || skeletonLoading || saving ? "disabled" : ""} */}
              <SettingsSidebar
                emailId={design.data.asset_id}
                emailName={design.data.version_name}
                handleSaveAsEmail={handleSaveAsEmail}
                handleSaveEmail={handleSaveEmail}
                toggleDisabled={toggleDisabled}
                enableSaveButtons={enableSaveButtons}
              // saveLoading={saving || skeletonLoading || loading || saveSuccess}
              />
              <div className="scrollable">
                {design.data.asset_type === ASSET_TYPE.HYBRID && (
                  <TemplateSwitch
                    changeTemplate={(value: number, value1: string) => {
                      changeTemplate(value, value1);
                    }}
                    setTemplateStyleId={(value: number) => {
                      setTemplateStyleId(value);
                    }}
                    // disabled={(disablePreview && isDesign) || skeletonLoading || saving}
                    disabled={(disablePreview && isDesign)}
                    enableSaveButtons={enableSaveButtons}
                    templateStyleId={templateStyleId}
                  />
                )}
                <div id="load-controls"></div>
                {design.data.asset_type === ASSET_TYPE.HYBRID && !loadingArticles && (
                  <ArticleListOrder
                    // loading={saving || skeletonLoading || loading || saveSuccess} 
                    design={design.data}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {(toggleDisabled) && <div className="modal-backdrop fade show" />}

      </Wrapper>
    </>
  );
};
export default Design;

const Wrapper = styled.div`
  background-color: transparent !important;
  box-sizing: border-box;
  background-size: cover;
  /* min-height: 100vh; */
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  .warning-message-design {
    color: red;
    &div.ant-message-notice-content {
      background-color: orange;
    }
  }
  .warning-message-design.ant-message-notice-content {
      background-color: red;
  }
  .dark-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    height: 100vh;
    width: 100%;
    z-index: 10;
  }
  .content-inner {
    display: flex;
    align-self: flex-end;
    flex-direction: column;
    background-color: #fff;
    box-sizing: border-box;
    /* width: calc(100% - 88px); */
    margin: 5px -90px 0 -90px;
    width: calc(100% + 180px) !important;
    float: right;
    /* min-height: 100vh; */
    min-height: auto !important;
    background-color: #f9f8f6;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      /* width: calc(100% - 63px); */
      margin: 15px -65px 0 -65px;
      width: calc(100% + 130px) !important;
    }
  }
  .designWraper {
    display: flex;
    flex-wrap: wrap;
    margin: 0 10px;
    position: relative;
    .preview-wraper {
      border: 1px solid #b5c3d4;
      -webkit-box-flex: 0;
      -ms-flex: 0 0 70%;
      flex: 0 0 70%;
      // min-width: 870px;
      overflow: hidden;
      position: relative;
      height: calc(100vh - 160px);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: calc(100vh - 130px);
      }
      @media all and (min-width: 1440px) {
        min-width: 870px;
      }
    }
    .settings-wraper {
      border: 1px solid #b5c3d4;
      margin-left: 15px;
      -webkit-box-flex: 0;
      -ms-flex: 0 0 calc(30% - 15px);
      flex: 0 0 calc(30% - 15px);
      overflow: hidden;
      height: calc(100vh - 160px);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: calc(100vh - 130px);
      }
      @media all and (min-width: 1440px) {
        max-width: calc(100% - 885px);
      }
      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
      .scrollable {
        max-height: calc(100vh - 245px);
        overflow: auto;
        scrollbar-width: thin;
        scrollbar-color: #001760 transparent;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          max-height: calc(100vh - 220px);
        }
        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
          border-radius: 5px;
        }
        /* Track */
        &::-webkit-scrollbar-track {
          background: #fff;
          margin-top: 10px;
          margin-bottom: 15px;
        }
        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #001760;
        }
        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      }
    }
  }
  .designWrapper {
    .preview-screen {
      height: 100vh;
      background-color: #f9f8f6;
      z-index: -999;
      display: none;
      padding-right: 15px;
      transition: 0.5s;
      position: fixed;
      top: 0;
      left: 88px;
      width: calc(100% - 88px);
      padding-top: 25px;
      border-right: 1px solid #b5c3d4;
      overflow: auto;
      box-sizing: border-box;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: calc(100% - 63px);
        left: 63px;
      }
      &.active {
        z-index: 9;
        display: block;
      }
      .ant-tabs-nav {
        .ant-tabs-nav-list {
          transform: translate(-50%, 0px) !important;
          left: 50% !important;
          .ant-tabs-tab {
            margin-left: 0px;
            border-radius: 8px 0 0 8px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              border-radius: 6px 0 0 6px;
            }
            + .ant-tabs-tab {
              margin-left: 0px;
              border-radius: 0 8px 8px 0;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                border-radius: 0 6px 6px 0;
              }
            }
          }
        }
      }
      .preview-label {
        position: absolute;
        top: 20px;
        left: 25px;
        color: #424b50;
        font-family: "Roboto Slab", serif;
        font-weight: 500;
        font-size: 32px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 24px;
          top: 25px;
        }
      }
      .close-preview {
        position: absolute;
        top: 30px;
        right: 20px;
        z-index: 9;
        cursor: pointer;
      }
    }
    // .preview-screen {
    //   height: 100vh;
    //   background-color: #f9f8f6;
    //   z-index: -999;
    //   display: none;
    //   padding-right: 15px;
    //   transition: 0.5s;
    //   position: fixed;
    //   top: 0;
    //   left: 88px;
    //   width: calc(70% - 65px);
    //   padding-top: 25px;
    //   border-right: 1px solid #b5c3d4;
    //   overflow: auto;
    //   box-sizing: border-box;
    //   &.active {
    //     z-index: 9;
    //     display: block;
    //   }
    //   .close-preview {
    //     position: absolute;
    //     top: 30px;
    //     right: 20px;
    //     z-index: 9;
    //     cursor: pointer;
    //   }
    // }
  }
  #load-controls {
    .nav-tabs.nav-justified {
      display: block;
    }
  }
`;
